import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";
import emailjs from "emailjs-com";

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "", // نام کاربر
      phone_number: "", // شماره تلفن
      email: "", // ایمیل
      subject: "", // موضوع پیام
      message: "", // متن پیام
      formErrors: {}, // نگهداری خطاهای فرم
      submittedIPs: new Set(), // ذخیره IP های ارسال‌کننده قبلی
      userIP: null, // IP کاربر جاری
      successMessage: "", // پیام موفقیت
      errorMessage: "", // پیام خطا
    };
  }

  // دریافت IP کاربر هنگام mount شدن کامپوننت
  componentDidMount() {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => this.setState({ userIP: data.ip }));
  }

  // کنترل تغییرات input ها و textarea
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // اعتبارسنجی فرم و بررسی required بودن فیلدها
  validateForm = () => {
    const errors = {};
    const { name, email, subject, message } = this.state;

    if (!name.trim()) errors.name = "لطفاً نام خود را وارد کنید";
    if (!email.trim()) errors.email = "لطفاً ایمیل خود را وارد کنید";
    else if (!/\S+@\S+\.\S+/.test(email))
      errors.email = "ایمیل معتبر وارد کنید";

    if (!subject.trim()) errors.subject = "لطفاً موضوع پیام را وارد کنید";
    if (!message.trim()) errors.message = "لطفاً متن پیام را وارد کنید";

    return errors;
  };

  // تابع ارسال فرم
  handleSubmit = (e) => {
    e.preventDefault();

    const { userIP, submittedIPs } = this.state;

    // بررسی ارسال قبلی توسط این IP
    if (submittedIPs.has(userIP)) {
      this.setState({
        errorMessage: "شما قبلاً پیام خود را ارسال کرده‌اید",
        successMessage: "",
      });
      return;
    }

    // بررسی اعتبار فرم
    const formErrors = this.validateForm();
    if (Object.keys(formErrors).length > 0) {
      this.setState({ formErrors, successMessage: "", errorMessage: "" });
      return;
    }

    // آماده‌سازی داده‌ها برای ارسال با EmailJS
    const templateParams = {
      from_name: this.state.name,
      from_email: this.state.email,
      phone_number: this.state.phone_number,
      subject: this.state.subject,
      message: this.state.message,
      user_ip: userIP,
    };

    // ارسال ایمیل
    emailjs
      .send(
        "service_y0fc3to",
        "template_elaeh64",
        templateParams,
        "Zr5A_ReppnGutiChA"
      )
      .then(() => {
        // اگر ارسال موفق بود
        this.setState((prevState) => ({
          submittedIPs: new Set(prevState.submittedIPs).add(userIP),
          name: "",
          phone_number: "",
          email: "",
          subject: "",
          message: "",
          formErrors: {},
          successMessage: "پیام شما با موفقیت ارسال شد. متشکرم!",
          errorMessage: "",
        }));
        document.getElementById("contactForm").reset(); // ریست فرم
      })
      .catch(() => {
        // اگر ارسال ناموفق بود
        this.setState({
          errorMessage: "ارسال پیام ناموفق بود. لطفاً دوباره تلاش کنید",
          successMessage: "",
        });
      });
  };

  render() {
    if (!this.props.data) return null;

    const { formErrors, successMessage, errorMessage } = this.state;
    const {
      name,
      phone,
      email,
      address: { city, country },
    } = this.props.data;

    return (
      <section id="contact">
        {/* بخش عنوان و توضیحات فرم */}
        <Fade bottom duration={1000}>
          <div className="row section-head">
            <div className="two columns header-col">
              <span>
                <i className="fa fa-envelope fa-mail" aria-hidden="true"></i>
              </span>
              <p className="lead ten columns">
                {this.props.data.contactmessage}
              </p>
            </div>
          </div>
        </Fade>

        <div className="row">
          {/* فرم تماس */}
          <Slide left duration={1000}>
            <div className="eight columns">
              <form
                id="contactForm"
                name="contactForm"
                onSubmit={this.handleSubmit}
              >
                <fieldset>
                  {/* نمایش پیام موفق یا خطا */}
                  {successMessage && (
                    <div className="success-message">{successMessage}</div>
                  )}
                  {errorMessage && (
                    <div className="error-message">{errorMessage}</div>
                  )}

                  {/* فیلد نام */}
                  <div>
                    <label htmlFor="contactName">
                      Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="contactName"
                      name="name"
                      value={this.state.name}
                      onChange={this.handleChange}
                      required
                    />
                    {formErrors.name && (
                      <span className="error">{formErrors.name}</span>
                    )}
                  </div>

                  {/* فیلد شماره تلفن */}
                  <div>
                    <label htmlFor="contactPhone">Phone Number</label>
                    <input
                      type="text"
                      id="contactPhone"
                      name="phone_number"
                      placeholder="e.g: 09123456789"
                      value={this.state.phone_number}
                      onChange={this.handleChange}
                    />
                  </div>

                  {/* فیلد ایمیل */}
                  <div>
                    <label htmlFor="contactEmail">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="email"
                      id="contactEmail"
                      name="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      required
                    />
                    {formErrors.email && (
                      <span className="error">{formErrors.email}</span>
                    )}
                  </div>

                  {/* فیلد موضوع */}
                  <div>
                    <label htmlFor="contactSubject">
                      Subject <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="contactSubject"
                      name="subject"
                      value={this.state.subject}
                      onChange={this.handleChange}
                      required
                    />
                    {formErrors.subject && (
                      <span className="error">{formErrors.subject}</span>
                    )}
                  </div>

                  {/* فیلد پیام */}
                  <div>
                    <label htmlFor="contactMessage">
                      Message <span className="required">*</span>
                    </label>
                    <textarea
                      id="contactMessage"
                      name="message"
                      cols="50"
                      rows="15"
                      value={this.state.message}
                      onChange={this.handleChange}
                      required
                      style={{ resize: "none" }}
                    ></textarea>
                    {formErrors.message && (
                      <span className="error">{formErrors.message}</span>
                    )}
                  </div>

                  {/* دکمه ارسال */}
                  <div>
                    <button type="submit" className="submit">
                      Submit
                    </button>
                  </div>
                </fieldset>
              </form>
            </div>
          </Slide>

          {/* بخش اطلاعات تماس */}
          <Slide right duration={1000}>
            <aside className="four columns footer-widgets">
              <div className="widget widget_contact">
                <h2>Contact Details</h2>
                <p className="address">
                  <span>
                    <i className="fa fa-user-circle contact-i"></i> {name}
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-map-marker contact-i"></i> {city},{" "}
                    {country}
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-mobile contact-i"></i> {phone}
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-envelope contact-i"></i> {email}
                  </span>
                </p>
              </div>
            </aside>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Contact;
